import React from 'react'

const Engineering = () => (
  <svg width="14.25em" viewBox="0 0 228 86" fill="none">
    <circle
      cx="42.6398"
      cy="42.6398"
      r="39.6398"
      stroke="#FDAD2A"
      strokeWidth={6}
    />
    <path
      d="M127.109 34.9734C128.877 36.736 131.13 38.9887 133.066 40.9447L134.086 41.9746L133.091 43.029C131.157 45.0809 128.906 47.4572 127.138 49.32C126.255 50.2515 125.492 51.0549 124.95 51.6253L124.087 52.5333L121.913 50.4664L122.775 49.5592C123.317 48.9891 124.079 48.1863 124.962 47.2554C126.03 46.129 127.275 44.8155 128.52 43.5H96.001C96.0008 43.5 96 43.5 96 42C96 40.5 96.0001 40.5 96.0002 40.5H128.394C127.202 39.3043 126.015 38.1192 124.991 37.0977C124.108 36.2173 123.346 35.459 122.805 34.9207L121.944 34.0656L121.943 34.0648L124.057 31.9354L124.92 32.7934C125.462 33.3325 126.225 34.0919 127.109 34.9734Z"
      fill="#8F8F8F"
    />
    <rect
      x={148}
      y={4}
      width={77}
      height={77}
      stroke="#21C97B"
      strokeWidth={6}
    />
  </svg>
)

export default Engineering
